import React, { useEffect, useState } from 'react'

const ContactosContext = React.createContext({})

export const ContactosProvider = ({ children }) => {
  const [contactos, setContactos] = useState([])
  // const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true) // Nuevo estado para manejar la carga

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([getContactos()]) // Ejecuta ambas funciones en paralelo
      } catch (error) {
        console.error('Error al obtener los datos:', error)
      } finally {
        setLoading(false) // Se marca como falso después de que los datos se carguen o haya un error
      }
    }

    fetchData()
  }, [])

  const getContactos = async () => {
    try {
      const res = await fetch('https://acffrancosservices.b4a.app/api/v2/contactos')
      const data = await res.json()
      const ctc = data.data.map(contacto => ({
        name: contacto.name,
        number: contacto.phone
      }))
      setContactos(ctc)
    } catch (error) {
      console.error('Error al obtener contactos:', error)
    }
  }

  if (loading) {
    return <div>Cargando contactos...</div> // Evita que la app renderice mientras no haya datos
  }

  return (
    <ContactosContext.Provider value={{ contactos, getContactos }}>
      {children}
    </ContactosContext.Provider>
  )
}

export default ContactosContext
